import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  Container,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    { title: 'Home', path: '/' },
    { title: 'About', path: '/about' },
    { title: 'Programs', path: '/programs' },
    { title: 'Membership', path: '/membership' },
    { title: 'Leadership', path: '/leadership' },
  ];

  const drawer = (
    <Box onClick={handleDrawerToggle} className="w-64 bg-background h-full" role="navigation" aria-label="Mobile navigation menu">
      <div className="flex justify-end p-4">
        <IconButton aria-label="Close navigation menu">
          <CloseIcon />
        </IconButton>
      </div>
      <List>
        {menuItems.map((item) => (
          <ListItem
            component={Link}
            to={item.path}
            key={item.title}
            selected={location.pathname === item.path}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(26, 77, 46, 0.1)',
              },
              '&.Mui-selected': {
                backgroundColor: 'rgba(26, 77, 46, 0.08)',
              },
            }}
          >
            <ListItemText
              primary={item.title}
              sx={{
                '& .MuiTypography-root': {
                  color: location.pathname === item.path ? '#1A4D2E' : 'inherit',
                  fontWeight: location.pathname === item.path ? 600 : 400,
                },
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="fixed" className="bg-white shadow-md" elevation={0} sx={{ backgroundColor: 'white', top: 0, zIndex: 1100 }}>
        <Container maxWidth="xl">
          <Toolbar sx={{ py: 1, minHeight: { xs: 56, sm: 64 } }}>
            <Link to="/" className="no-underline flex-1 md:flex-none" aria-label="Meiyal Foundation Home">
              <div className="flex items-center gap-3">
                <img 
                  src="/2.png" 
                  alt="Meiyal Foundation Logo" 
                  loading="eager"
                  className="h-10 sm:h-12 md:h-14 w-auto object-contain"
                />
                <h1 className="text-xl sm:text-2xl md:text-3xl font-bold font-poppins" style={{ color: '#1A4D2E' }}>
                  Meiyal Foundation
                </h1>
              </div>
            </Link>

            {/* Desktop Menu */}
            <Box component="nav" className="hidden md:flex ml-auto space-x-6" aria-label="Main navigation">
              {menuItems.map((item) => (
                <Link
                  key={item.title}
                  to={item.path}
                  style={{
                    textDecoration: 'none',
                    color: location.pathname === item.path ? '#1A4D2E' : '#4A5568',
                    fontWeight: location.pathname === item.path ? 600 : 400,
                    fontSize: '1rem',
                    transition: 'color 0.3s ease',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = '#C4A484';
                  }}
                  onMouseLeave={(e) => {
                    if (location.pathname !== item.path) {
                      e.target.style.color = '#4A5568';
                    } else {
                      e.target.style.color = '#1A4D2E';
                    }
                  }}
                >
                  {item.title}
                </Link>
              ))}
            </Box>

            {/* Mobile Menu Button */}
            <IconButton
              color="inherit"
              aria-label="Open navigation menu"
              aria-expanded={mobileOpen}
              aria-controls="mobile-navigation-drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ 
                color: '#1A4D2E',
                display: { xs: 'flex', md: 'none' },
                ml: 'auto',
              }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        id="mobile-navigation-drawer"
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        aria-label="Mobile navigation drawer"
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Navbar;
